import showToastr from "../../../util/toastr.js";
import * as domainConstants from "../../../constants/DomainConstants";
import voortgangsrapportBeoordelingcriteriaApi from "../../../api/voortgangsrapportBeoordelingscriteriaApi";

import redirector from "../../../util/redirector.js";
import { getStore } from "../../../store/configureStore";

export default class VRBeoordelingscriteriaPageHelper {
	constructor(context, redirector) {
		this.dispatch = getStore().dispatch;
		this.context = context;
		this.redirector = redirector;
	}

	init() {
		const { vrLoaded, vrProjectId, loadLayout } = this.context.props;

		if (!vrLoaded)
			redirector.goTo("voortgangsrapport/project/" + vrProjectId);

		this.context.props.ajaxStarted();
		voortgangsrapportBeoordelingcriteriaApi.get(vrProjectId).then(response => {
			this.context.props.ajaxEnded();

			const vrBeoordelingscriteria = response.data.item;
			const errors = response.data.validationResults || {};
			this.context.props.beadsLoaded(vrBeoordelingscriteria.beadModels);

			this.context.setState({
				vrBeoordelingscriteria,
				errors
			});

			loadLayout(vrProjectId, true);
		}).catch(error => {
			this.context.props.ajaxFailed(error);
			this.context.props.throwException(error);
		});
	}

	onChange(event, data) {
		const field = event.target.name;
		const vrBeoordelingscriteria = this.context.state.vrBeoordelingscriteria;
		vrBeoordelingscriteria[field] = event.target.value;

		if (field === "wijzigingenCriteriaBehoefte" && event.target.value == "false") {
			vrBeoordelingscriteria["toelichtingWijzigingenCriteriumBehoefte"] = "";
		}

		if (field === "wijzigingenCriteriaBereik" && event.target.value == "false") {
			vrBeoordelingscriteria["toelichtingWijzigingenCriteriumBereik"] = "";
		}

		return this.context.setState({
			vrBeoordelingcriteria: vrBeoordelingscriteria,
			hasUnsavedChanges: true
		});
	}

	onSave() {
		this.context.props.ajaxStarted();

		voortgangsrapportBeoordelingcriteriaApi.save(this.context.state.vrBeoordelingscriteria)
			.then((response) => {
				let vrBeoordelingscriteria = response.data.item;
				this.context.props.ajaxEnded();
				let result = null;
				if (response.data.concurrencyException) {
					this.context.setState({ vrBeoordelingscriteria, errors: response.data.validationResults });
					result = domainConstants.HAS_CONCURRENCY_EXCEPTION;
				} else if (response.data.hasValidationErrors) {
					this.context.setState({ vrBeoordelingscriteria, errors: response.data.validationResults });
					result = domainConstants.HAS_VALIDATION_ERRORS;
				} else if (Object.keys(response.data.validationResults).length !== 0) {
					this.context.setState({ vrBeoordelingscriteria, errors: response.data.validationResults });
					result = domainConstants.HAS_VALIDATION_ERRORS_SAVED;
				} else {
					this.context.setState({ vrBeoordelingscriteria, errors: null });
					result = domainConstants.SUCCESS;
				}

				let isSaved = showToastr(result);

				if (isSaved) {
					this.context.props.loadLayout(this.context.props.vrProjectId, true);
					this.context.props.beadsLoaded(vrBeoordelingscriteria.beadModels);
					this.context.setState({
						hasUnsavedChanges: false
					});
				}
			}).catch(error => {
				this.context.props.ajaxFailed(error);
				this.context.props.throwException(error);
			});
	}
}